


























import {Component, Vue} from 'vue-property-decorator';
import TimestablesSelect from "@/components/math/timestables.select.vue";
import LearnMathTask from "@/components/math/learn.math.task.vue";


@Component({
    components: {
        TimestablesSelect,
        LearnMathTask
    }
})

export default class numberInput extends Vue {

    onNumberClick(number:number) {
        this.$emit("numberClick", number);
    }

    private clearSolution(){
        this.$emit("clearSolution");
    }
}

